/** Мобильный диалог редких команд верхнего тулбара. */
import { UIKit } from "@/shared/ui";
import { ExportDialog } from "@/widgets/plan-export";

interface Props {
	open: boolean;
	onClose: () => void;
	drawingDisabled: boolean;
	commentActive: boolean;
	eraseActive: boolean;
	onToggleComment: () => void;
	onToggleErase: () => void;
	/** Открыта ли смета */
	estimateActive: boolean;
	onToggleEstimate: () => void;
	onReset: () => void;
}

export const ToolbarMobileModal = ({
	open,
	onClose,
	drawingDisabled,
	commentActive,
	eraseActive,
	onToggleComment,
	onToggleErase,
	estimateActive,
	onToggleEstimate,
	onReset,
}: Props) => {
	if (!open) return null;

	const selectTool = (action: () => void) => {
		action();
		onClose();
	};

	return (
		<UIKit.Modal
			ariaLabel="Действия"
			className="max-h-toolbar-mobile px-4 pt-3 pb-safe-bottom"
			containerClassName="md:hidden"
			onClose={onClose}
		>
			<div className="mb-3 flex items-center justify-between">
				<UIKit.Text className="text-sm font-semibold text-ink">Действия</UIKit.Text>
				<UIKit.Button
					type="button"
					border={false}
					className="ml-1 p-0 text-ink transition-colors hover:text-ink"
					onClick={onClose}
					aria-label="Закрыть"
				>
					✕
				</UIKit.Button>
			</div>

			<div className="grid grid-cols-2 gap-2">
				{!drawingDisabled && (
					<>
						<UIKit.IconButton
							className="h-18 gap-1"
							icon={<UIKit.IconComment />}
							label="Комментарий"
							active={commentActive}
							onClick={() => selectTool(onToggleComment)}
						/>
						<UIKit.IconButton
							className="h-18 gap-1"
							icon={<UIKit.IconTrash />}
							label="Удалить"
							active={eraseActive}
							onClick={() => selectTool(onToggleErase)}
						/>
					</>
				)}
				<ExportDialog mobile />
				<UIKit.IconButton
					className="h-18 gap-1"
					icon={<UIKit.IconEstimate />}
					label="Смета"
					active={estimateActive}
					onClick={() => selectTool(onToggleEstimate)}
				/>
				{!drawingDisabled && (
					<UIKit.IconButton
						className="h-18 gap-1"
						icon={<UIKit.IconReset />}
						label="Сбросить"
						onClick={() => selectTool(onReset)}
					/>
				)}
			</div>
		</UIKit.Modal>
	);
};
